export enum ActionType {
    SET_USER = 'SET_USER',
    SET_USER_ROLE = 'SET_USER_ROLE',
    SET_ACCOUNT_ACTIVE_STATE = 'SET_ACCOUNT_ACTIVE_STATE',
    SET_AUTH_STATE = 'SET_AUTH_STATE'
}